import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, createElement } from "lwc";
import _tmpl from "./attachFiles.html";
import LightningElementSLDS from 'util/lightningElementSLDS';
import { eventTypes, fireEvent, registerListener, unregisterAllListeners } from 'util/pubsub';
import lightningButtonIcon from 'lightning/buttonIcon';
//import { initializeGapi, revokeGoogleDriveAccess, handleAuthClickOAuth2, createPicker, getIsSignedIntoGoogle } from 'util/googleDrivePicker';

//CRN240227 - Added photo capture capabilities.

class AttachFiles extends LightningElementSLDS {
  constructor() {
    // <canvas className="snappedPhotoCanvas" width="640px" height="480px"></canvas>

    super();
    this.pageRef = {
      attributes: {
        "developer": "zPaper",
        "application": "Document Viewer"
      }
    };
    this.acceptedDocTypes = ".docx,.pdf,.png,.jpeg";
    this.attachedFilesDialog = void 0;
    this.photoShootPanel = void 0;
    this.$photoShootDialog = void 0;
    this.photoShootDialogIsVisible = false;
    this.videoStream = void 0;
    this.videoWidth = void 0;
    this.videoHeight = void 0;
    this.mobileCanvasWidth = void 0;
    this.mobileCanvasHeight = void 0;
    this.$snappedPhotoCanvasDiv = void 0;
    this.$photoCanvas = void 0;
    this.$photoCanvasOverlay = void 0;
    this.$photoVideo = void 0;
    this.$photoShootButton = void 0;
    this.$cameraSwitchButton = void 0;
    // $photoCropButton;
    this.docType = void 0;
    this.cameraFacing = "user";
    this.isSignedInToGoogle = false;
    this.originalButtonLabel = void 0;
    this.isActualMobile = false;
    this.viewAttachmentButtonLabel = void 0;
    this.fileCount = 0;
    this.docTypes = void 0;
    this.docSources = [{
      label: "Local Drive",
      value: "local-drive"
    }, {
      label: "Google Drive",
      value: "google-drive"
    }];
    this.files = [];
    const self = this;
    // If the phone changes orientation, fix up our dialog, video, and canvas sizes.
    screen.orientation.addEventListener('change', event => {
      self.resizePhotoCaptureElements();
    });
    this.isActualMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|Mobi|Opera Mini/i.test(navigator.userAgent) || 'ontouchstart' in document.documentElement;
    this.docTypes = [{
      //ERS240605 #109151 overwritten by view.json generally
      label: "Insurance Card",
      value: "card"
    }];
  }
  get displayFiles() {
    return this.files.length > 0;
  }
  connectedCallback() {
    window.attachFilesCmp = this;
    this.isSignedInToGoogle = getIsSignedIntoGoogle();
    registerListener(eventTypes.GOOGLE_SIGN_IN_STATUS_UPDATE, this.handleGoogleSignInStatusupdate, this);
    initializeGapi();
  }
  handleGoogleSignInStatusupdate(evt) {
    this.isSignedInToGoogle = evt.isSignedInToGoogle;
  }
  get isLoggedInToGoogle() {
    return this.isSignedInToGoogle;
  }
  renderedCallback() {
    if (!this.originalButtonLabel && this.viewAttachmentButtonLabel) {
      this.originalButtonLabel = this.viewAttachmentButtonLabel;
    }
    let self = this;
    //window.attachedFilesCmp = this;
    if (!this.attachedFilesDialog) {
      console.log("initializing dialog ", this.template.querySelector(".attachedFilesPanel"));
      self.attachedFilesDialog = $(this.template.querySelector(".attachedFilesPanel")).dialog({
        autoOpen: false,
        modal: true,
        buttons: {
          "Ok": {
            text: 'Ok',
            click: function () {
              $(this).dialog("close");
            }
          }
        },
        beforeClose: function (evt, ui) {
          if (self.files.length > 0) {
            self.viewAttachmentButtonLabel = `${self.originalButtonLabel} (${self.files.length})`;
          } else if (self.files.length == 0) {
            self.viewAttachmentButtonLabel = `${self.originalButtonLabel}`;
          }
          let attachedFile = $(this).children(".attachedFilesPanelHeader").find("input[type='file']").prop("files")[0];
          if (attachedFile) {
            if (confirm("File has been selected, but not attached") == true) {
              $(this).find("input[type='file']").val('');
              $(this).find(".slds-file-selector__text").html('');
            } else {
              return false;
            }
          }
        },
        open: function (event, ui) {
          // $("span.ui-dialog-title").text('Submit Files');

          $(this).find("table").html("");
          $(this).find("table").append(self.getFilesTable(this));
          if (!__g_JqueryCloseBtn) {
            $(".ui-dialog-titlebar-close").hide();
          }
        }
      });
    }
    if (!this.$photoShootDialog) {
      this.buildPhotoCaptureDialog();
    }
  }
  resizePhotoCaptureElements() {
    const dialogWidth = __g_isMobile ? window.innerWidth - 8 : 800;
    const dialogHeight = __g_isMobile ? window.innerHeight - 10 : 640;
    console.log("Window dimensions: width = ", window.innerWidth, ", height = ", window.innerHeight);
    this.mobileCanvasWidth = dialogWidth - 2;
    this.mobileCanvasHeight = this.mobileCanvasWidth * (480 / 640);
    if (this.$photoShootDialog && this.photoShootDialogIsVisible) {
      console.log("RESIZING THE PHOTO CATCH DIALOG");
      this.$photoShootDialog.dialog("option", "width", dialogWidth);
      this.$photoShootDialog.dialog("option", "height", dialogHeight);
      // If we are currently streaming video, stop and restart it.
      this.stopVideo();
      this.handlePhotoShoot();
    }
  }
  stopVideo() {
    if (this.videoStream) {
      const videoEle = this.$photoVideo[0];
      videoEle.pause();
      videoEle.srcObject = null;
      this.videoStream.getTracks()[0].stop();
      this.videoStream = null;
    }
  }
  switchCamera() {
    this.cameraFacing = "user" === this.cameraFacing ? "environment" : "user";
    this.stopVideo();
    this.handlePhotoShoot();
  }
  buildPhotoCaptureDialog() {
    const self = this;
    const dialogWidth = __g_isMobile ? window.innerWidth - 8 : 800;
    const dialogHeight = __g_isMobile ? window.innerHeight - 10 : 640;
    this.photoShootPanel = document.createElement("div");
    this.photoShootPanel.classList.add("photoShootPanel");
    const $dialogBody = $(this.photoShootPanel);
    $dialogBody.css('display', 'flex');
    $dialogBody.css('flex-direction', 'column');
    $dialogBody.css('align-items', 'center');
    this.$photoVideo = $("<video class=\"photoShootVideo\" style=\"width: 640px; height: 480px;\" autoplay playsinline></video>");
    this.$snappedPhotoCanvasDiv = $('<div class="snappedPhotoCanvasDiv canvasWrapper" style="position: relative;z-index: -1;"></div>');
    this.$photoCanvas = $(document.createElement("canvas"));
    this.$photoShootButton = $("<div class=\"snapPhotoBtn\">Capture</div>");
    this.$photoShootButton.css("position", "absolute");
    this.$photoShootButton.css("bottom", "-20px");
    this.$photoShootButton.css("width", "100px");
    this.$photoShootButton.css("height", "100px");
    this.$photoShootButton.css("border-radius", "50%");
    this.$photoShootButton.css("cursor", "pointer");
    this.$photoShootButton.css("text-align", "center");
    this.$photoShootButton.css("background-color", "gainsboro");
    this.$photoShootButton.css("font-size", "1.5em");
    this.$photoShootButton.css("margin", "20px");
    this.$photoShootButton.css("line-height", "100px");
    this.$photoShootButton.css("font-weight", "bold");
    if (this.isActualMobile) {
      this.$cameraSwitchButton = $(`<div class="switchCameraBtn">
                    <img src="resources/switch-camera-clean.png" />
                </div>`);
      this.$cameraSwitchButton.css("position", "absolute");
      this.$cameraSwitchButton.css("bottom", "-20px");
      this.$cameraSwitchButton.css("right", "20px");
      this.$cameraSwitchButton.css("width", "80px");
      this.$cameraSwitchButton.css("height", "80px");
      this.$cameraSwitchButton.css("border-radius", "50%");
      this.$cameraSwitchButton.css("cursor", "pointer");
      this.$cameraSwitchButton.css("text-align", "center");
      this.$cameraSwitchButton.css("background-color", "gainsboro");
      this.$cameraSwitchButton.css("font-size", "1.5em");
      this.$cameraSwitchButton.css("margin", "20px");
      this.$cameraSwitchButton.css("line-height", "80px");
      $dialogBody.append(this.$cameraSwitchButton);
      this.$cameraSwitchButton.click(evt => {
        this.switchCamera();
      });
    }
    this.$snappedPhotoCanvasDiv.append(this.$photoCanvas);
    $dialogBody.append(this.$photoVideo);
    $dialogBody.append(this.$photoShootButton);
    $dialogBody.append(this.$snappedPhotoCanvasDiv);
    this.$photoShootButton.css("z-index", "10000");
    if (this.$cameraSwitchButton) {
      this.$cameraSwitchButton.css("z-index", "10000");
    }
    this.$photoShootButton.click(evt => {
      this.capturePhoto();
    });
    console.log("Window dimensions: width = ", window.innerWidth, ", height = ", window.innerHeight);
    this.mobileCanvasWidth = dialogWidth - 2;
    this.mobileCanvasHeight = this.mobileCanvasWidth * (480 / 640);
    this.$docTypeSelect = $(this.template.querySelector(".slds-select"));
    this.$photoShootButton.show();
    if (this.isActualMobile) {
      this.$cameraSwitchButton.show();
    }
    this.photoShootDialogIsVisible = false;
    this.$photoShootDialog = __g_zPDF_dialogHelper.createDialog($dialogBody[0], {
      autoOpen: false,
      modal: true,
      width: dialogWidth,
      height: dialogHeight,
      buttons: {
        "Crop": {
          id: "CropBtn",
          text: 'Crop',
          click: function (evt) {
            self.stopVideo();
            const photoUrl = self.$photoCanvas[0].toDataURL();
            self.stopVideo();
            self.$photoShootDialog.parent().find('.ui-dialog-buttonpane').find('#CropBtn').hide();
            self.$photoShootDialog.parent().find('.ui-dialog-buttonpane').find('#OkBtn').hide();
            self.$photoShootDialog.parent().find('.ui-dialog-buttonpane').find('#CancelBtn').hide();
            self.cropPhoto(photoUrl);
          }
        },
        "Ok": {
          id: "OkBtn",
          text: 'Ok',
          click: function (evt) {
            self.stopVideo();
            const photoUrl = self.$photoCanvas[0].toDataURL();
            const imgFile = {
              name: "Photo taken from device",
              imgData: photoUrl
            };
            self.addFile(imgFile, self.docType, self.attachedFilesDialog);
            self.closePhotoShootDialog();
          }
        },
        "Cancel": {
          id: "CancelBtn",
          text: 'Cancel',
          click: function () {
            self.stopVideo();
            self.closePhotoShootDialog();
          }
        }
      },
      beforeClose: function (evt, ui) {
        self.photoShootDialogIsVisible = false;
        $("span.ui-dialog-title").text('Submit Files');
      }
    });
  }
  closePhotoShootDialog() {
    this.$photoVideo.show();
    this.$photoShootButton.show();
    if (this.isActualMobile) {
      this.$cameraSwitchButton.show();
    }
    this.$photoCanvas.hide();
    if (this.$snappedPhotoCanvasDiv) {
      this.$snappedPhotoCanvasDiv.css('z-index', '-1');
    }
    this.photoShootDialogIsVisible = false;
    this.attachedFilesDialog.dialog("open");
    this.$photoShootDialog.dialog("close");
    this.photoShootDialogIsVisible = false;
    this.$photoShootDialog.parent().find('.ui-dialog-buttonpane').find('#OkBtn').show();
    this.$photoShootDialog.parent().find('.ui-dialog-buttonpane').find('#CancelBtn').show();
  }
  handleDocSourceChange(evt) {
    //get selected data source
    let docSource = evt.target.value;
    //hide all file input panels
    $(evt.target).closest(".attachedFilesPanelHeader").find(".fileInputPanels .fileInputPanel").addClass("display-none");
    //show only currently selected panel
    $(evt.target).closest(".attachedFilesPanelHeader").find(".fileInputPanels .fileInputPanel." + docSource).removeClass("display-none");
  }
  signInWithGoogle() {
    handleAuthClickOAuth2();
  }
  callRevokeGoogleDriveAccess() {
    revokeGoogleDriveAccess();
  }
  getFilesTable(thisRef) {
    let self = this;
    let filesTable = $(thisRef).find("table");
    let filesTableHeaderRow = $("<tr><th>Attached File(s)</th><th></th></tr>");
    $(filesTable).append(filesTableHeaderRow);
    self.fileCount = this.files.length;
    this.files.forEach(file => {
      let fileRow = $("<tr></tr>");
      let fileNameCol = $("<td>" + file.docTypeLabel + " : " + file.name + "</td>");
      let deleteFileBtn = createElement("lightning-button-icon", {
        is: lightningButtonIcon
      });
      deleteFileBtn.iconName = "utility:delete";
      deleteFileBtn.dataset.fileNo = file.fileNo;
      deleteFileBtn.variant = "border-filled";
      deleteFileBtn.onclick = event => {
        this.deleteFile(event);
        this.refreshTable(thisRef);
      };
      let deleteFileCol = $("<td></td>");
      $(deleteFileCol).append(deleteFileBtn);
      $(fileRow).append(fileNameCol);
      $(fileRow).append(deleteFileCol);
      $(filesTable).append(fileRow);
    });
    return filesTable;
  }
  refreshTable(thisRef) {
    $(thisRef).find("table").html("");
    $(thisRef).find("table").append(this.getFilesTable(thisRef));
  }
  deleteFile(evt) {
    let deletedFileNo = evt.target.dataset.fileNo;
    this.files = this.files.filter(file => file.fileNo != deletedFileNo);
    this.files.forEach((file, fileIndexNo) => {
      file.fileNo = fileIndexNo + 1;
    });
    this.createAndSendFormData();
  }
  addFileFromLocalDrive(evt) {
    let docType = $(evt.target).closest(".attachedFilesPanelHeader").find(".slds-select").val();
    let attachedFile = $(evt.target).closest(".attachedFilesPanelHeader").find("input[type='file']").prop("files")[0];
    if (!attachedFile) {
      alert("Please select a file for upload");
      return;
    }
    this.addFile(attachedFile, docType, this.attachedFilesDialog);
    $(this.attachedFilesDialog).find("input[type='file']").val('');
    $(this.attachedFilesDialog).find(".slds-file-selector__text").html('');
  }
  addFileFromGoogleDrive(evt) {
    let docType = $(evt.target).closest(".attachedFilesPanelHeader").find(".slds-select").val();
    createPicker(this.pickerCallback); //using .bind(this) did not work
  }
  pickerCallback(data) {
    console.log("The Picker called us back.");
    let self = this;
    let action = data[google.picker.Response.ACTION];
    if (google.picker.Action.PICKED === action) {
      let documents = data[google.picker.Response.DOCUMENTS];
      gapi.client.drive.files.get({
        fileId: documents[0][google.picker.Document.ID],
        alt: "media" //added this parameter to get the actual file contents
      }).then(fileGetResp => {
        //convet pdf to unit8array
        let pdfUint8Arr = new Uint8Array(fileGetResp.body.length);
        for (let i = 0; i < fileGetResp.body.length; i++) {
          pdfUint8Arr[i] = fileGetResp.body.charCodeAt(i);
        }
        window.attachFilesCmp.addFile(new File(pdfUint8Arr, documents[0][google.picker.Document.NAME], {
          type: documents[0][google.picker.Document.MIME_TYPE]
        }), $(window.attachFilesCmp.attachedFilesDialog).find(".slds-select.docType").val(), window.attachFilesCmp.attachedFilesDialog);
      }).catch(fileGetError => {
        console.log("fileGetError", fileGetError);
        alert("An error occured while retrieving file attach file");
      });
    } else if (google.picker.Action.CANCEL === action) {}
  }
  addFile(newFile, docType, attachedFilesPanel) {
    try {
      let docTypeLabel;
      for (let i = 0; i < this.docTypes.length; i++) {
        if (docType === this.docTypes[i].value) {
          docTypeLabel = this.docTypes[i].label;
        }
      }
      let fileNumber = this.files.length + 1; //file number begins with 1
      let file = {
        fileNo: fileNumber,
        name: newFile.name,
        value: newFile,
        docType: docType,
        docTypeLabel: docTypeLabel
      };
      this.files.push(file);
      this.createAndSendFormData();
      this.refreshTable(attachedFilesPanel, this.files);
    } catch (attachErr) {
      alert("An error has occured while attaching the file");
      console.log("File Attach Error : ", attachErr);
    }
  }
  handleFileChange(evt) {
    if (evt.target.files[0]) {
      $(evt.target).closest(".attachedFilesPanelHeader").find(".slds-file-selector__text").html(evt.target.files[0].name);
    }
  }
  capturePhoto() {
    if (this.$photoCanvas && this.$photoCanvas.length > 0) {
      this.$photoShootDialog.parent().find('.ui-dialog-buttonpane').find('#CropBtn').show();
      this.$photoShootButton.hide();
      if (this.isActualMobile) {
        this.$cameraSwitchButton.hide();
      }
      if (this.$snappedPhotoCanvasDiv) {
        this.$snappedPhotoCanvasDiv.css('z-index', '0');
      }
      const context = this.$photoCanvas[0].getContext('2d');
      context.drawImage(this.$photoVideo[0], 0, 0, this.videoWidth, this.videoHeight);
      this.$photoVideo.hide();
      const videoEle = this.$photoVideo[0];
      videoEle.pause();
      videoEle.srcObject = null;
      this.videoStream.getTracks()[0].stop();
      this.videoStream = null;
      this.$photoCanvas.show();
    }
  }
  cropPhoto() {
    const self = this;
    const imgList = [];
    addMarkup(__g_zPDF_formHelper__, __g_zPDF_signatureHelper__, __g_pdfDoc___, "resources/SelectAreaClear.png", imgList, 180, 180, "img_select", this.$snappedPhotoCanvasDiv[0], ".snappedPhotoCanvasDiv", "resources/zpImages/scissors.png", function (imgList) {
      const imgData = imgList[0];
      console.log("imgData = ", imgData);
      const cropCanvas = document.createElement("canvas");
      cropCanvas.width = imgData.screenWidth;
      cropCanvas.height = imgData.screenHeight;
      // copy cropped area to new canvas and get its data url
      const destCtx = cropCanvas.getContext('2d');
      destCtx.drawImage(self.$photoCanvas[0], imgData.screenX, imgData.screenY, imgData.screenWidth, imgData.screenHeight, 0, 0, imgData.screenWidth, imgData.screenHeight);
      const photoUrl = cropCanvas.toDataURL();
      const imgFile = {
        name: "Photo taken from device",
        imgData: photoUrl
      };
      self.addFile(imgFile, self.docType, self.attachedFilesDialog);
      self.closePhotoShootDialog();
    }, function () {
      self.closePhotoShootDialog();
    }, true);
  }
  handlePhotoShoot(evt) {
    if (evt) {
      this.docType = $(evt.target).closest(".attachedFilesPanelHeader").find(".slds-select").val();
    }
    const videoWidth = __g_isMobile ? this.mobileCanvasWidth : 640;
    const videoHeight = __g_isMobile ? this.mobileCanvasHeight : 480;
    const constraints = {
      audio: false,
      video: {
        width: {
          min: videoWidth,
          ideal: videoWidth,
          max: videoWidth
        },
        height: {
          min: videoHeight,
          ideal: videoHeight,
          max: videoHeight
        }
      }
    };
    if (this.isActualMobile) {
      constraints.video['facingMode'] = {
        exact: this.cameraFacing
      };
    }
    console.log("cameraFacing = ", this.cameraFacing);
    const success = this.getVideoFeed(constraints, this.$photoVideo);
    if (!success) {
      alert("Couldn't get access to your camera. We can't capture your photo without your permission.");
    }
    const self = this;
    this.$photoVideo[0].addEventListener('playing', function () {
      self.videoWidth = this.videoWidth;
      self.videoHeight = this.videoHeight;
      console.log("Video width: ", this.videoWidth, ", height: ", this.videoHeight);
      self.$photoCanvas.attr('width', self.videoWidth);
      self.$photoCanvas.attr('height', self.videoHeight);
      self.$photoVideo.css('width', self.videoWidth + 'px');
      self.$photoVideo.css('height', self.videoHeight + 'px');
    });
    this.photoShootDialogIsVisible = true;
    this.attachedFilesDialog.dialog("close");
    self.$photoShootDialog.parent().find('.ui-dialog-buttonpane').find('#CropBtn').hide();
    this.$photoShootDialog.dialog("open");
    const dialogWidth = __g_isMobile ? window.innerWidth - 8 : 800;
    const dialogHeight = __g_isMobile ? window.innerHeight - 10 : 640;
    this.$photoShootDialog.dialog("option", "width", dialogWidth);
    this.$photoShootDialog.dialog("option", "height", dialogHeight);
    $("span.ui-dialog-title").text('Capture Photo');
  }
  async getVideoFeed(constraints, videoPanel) {
    try {
      if (videoPanel.length > 0) {
        const stream = await navigator.mediaDevices.getUserMedia(constraints);
        videoPanel[0].srcObject = stream;
        this.videoStream = stream;
        return true;
      }
      console.warn("Couldn't find our video playback panel!");
      return false;
    } catch (err) {
      console.error("Couldn't get access to camera: ", err);
    }
    return false;
  }
  createAndSendFormData() {
    let attachmentFormData = new FormData();
    let filteredFiles = this.files.filter(file => !!file.value);
    filteredFiles.forEach((file, fileIndex) => {
      console.log("file count : ", file.fileNo);
      console.log("doc type : ", file.docType);
      console.log("name : ", file.name);
      console.log("value : ", file.value);
      attachmentFormData.append("docType" + (fileIndex + 1), file.docType);
      // If the value is not an actual 'file' type, the FormData will turn it into a string ([object Object]), so stringify it here if needed.
      const value = file.value.imgData ? JSON.stringify(file.value) : file.value;
      attachmentFormData.append("template" + (fileIndex + 1), value);
    });
    console.log("printing out form data");
    for (var pair of attachmentFormData.entries()) {
      console.log(pair[0] + ', ' + pair[1]);
    }
    fireEvent(this.pageRef, eventTypes.PUBLISH_ATTACHMENT_FORM_DATA, {
      attachmentFormData: attachmentFormData
    });
  }
  handleViewAttachments() {
    $(this.attachedFilesDialog).dialog("open");
    $("span.ui-dialog-title").text('Submit Files');
    if (window.__g_isMobile) {
      __fixMobileDialogStyle($('.ui-dialog'));
    }
  }
}
_registerDecorators(AttachFiles, {
  publicProps: {
    viewAttachmentButtonLabel: {
      config: 0
    },
    docTypes: {
      config: 0
    }
  },
  fields: ["pageRef", "acceptedDocTypes", "attachedFilesDialog", "photoShootPanel", "$photoShootDialog", "photoShootDialogIsVisible", "videoStream", "videoWidth", "videoHeight", "mobileCanvasWidth", "mobileCanvasHeight", "$snappedPhotoCanvasDiv", "$photoCanvas", "$photoCanvasOverlay", "$photoVideo", "$photoShootButton", "$cameraSwitchButton", "docType", "cameraFacing", "isSignedInToGoogle", "originalButtonLabel", "isActualMobile", "fileCount", "docSources", "files"]
});
export default _registerComponent(AttachFiles, {
  tmpl: _tmpl
});